<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
    >
      <ul class="list-wrapper">
        <li
          v-for="item in newList"
          :key="item.id"
          class="pavilion-item"
          @click="handlerPerview(item)"
        >
          <img :src="item.thumbnail | thumbnail(698,462)">
          <div class="infoName">
            <span class="name">{{item.name}}</span>
            <span class="createTime">{{item.createTime}}</span>
          </div>
          <div class="star">
            <p>
              <i class="iconfont icon-yanjing_xianshi_o"></i>
              <span>{{item.view}}</span>
            </p>
            <p>
              <i class="iconfont icon-zanshoushi"></i>
              <span>{{item.sn}}</span>
            </p>
          </div>
          <!-- <img src="http://img.tutubox.cn/gemdefult.png"> -->
          <!-- <div class="pavilion-info">
            <div class="name">{{item.name}}</div>
            <div class="number">
              <span class="view">
                <i class="iconfont icon-yanjing_xianshi_o"></i>
                {{item.view}}
              </span>
              <span>
                <i class="iconfont icon-zanshoushi"></i>
                {{item.sn}}
              </span>
            </div>
            <div class="createTime">{{item.createTime}}创建</div>
          </div>-->
          <!-- <span class="indicate">
            GO
            <i class="iconfont icon-fangxiang1"></i>
          </span>-->
        </li>
      </ul>
    </van-list>
  </div>
</template>

<script>
import { List, Toast } from "vant";
import { pavilionList } from "@/api/pavilionReq";
export default {
  components: {
    [List.name]: List,
    [Toast.name]: Toast
  },

  data() {
    return {
      list: [],
      page: 0,
      loading: false,
      finished: false,
      error: false,
      total: 0,
      currentPage: 0,
      currentPageSize: 0
    };
  },
  watch: {
    newList(newVal) {
      if (!newVal) {
        Toast.fail("没有发布的展馆");
        this.loading = false;
        return;
      }
    }
  },
  computed: {
    newList() {
      if (this.list.length == 0) return;
      if (this.$route.query.public) {
        return this.list.filter(item => item.published);
      } else {
        return this.list;
      }
    }
  },
  methods: {
    onLoad() {
      this.page++;
      this.loading = true;
      pavilionList({ page: this.page })
        .then(res => {
          this.list = this.list.concat(res.list);
          this.loading = false;
          if (res.total < res.page * res.pageSize) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.error = true;
        });
    },
    handlerPerview(item) {
      this.$emit(
        "clickPavilion",
        item,
        this.total,
        this.currentPage,
        this.currentPageSize
      );
    }
  }
};
</script>

<style scoped lang="less">
// 注释为备份样式。
.list-wrapper {
  .pavilion-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 0 14px 15px 14px;
    background-color: #fff;
    border-radius: 6px;
    // height: 100px;
    // position: relative;
    // left: 50%;
    // transform: translateX(-50%);
    // width: 85%;
    // box-shadow: 1px 10px 21px 0px rgba(66, 83, 103, 0.08);
    // border-radius: 4px;
    // padding: 10px 0;
    // margin-bottom: 20px;
    // .pavilion-info {
    //   margin-left: 18px;
    //   .name {
    //     font-size: 15px;
    //     font-weight: 500;
    //     color: rgba(49, 49, 49, 1);
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     white-space: nowrap;
    //     width: 120px;
    //   }
    //   .number {
    //     margin-top: 15px;
    //     font-size: 13px;
    //     font-weight: 500;
    //     color: rgba(108, 108, 108, 1);
    //     .view {
    //       margin-right: 48px;
    //     }
    //   }
    //   .createTime {
    //     margin-top: 14px;
    //     font-size: 11px;
    //     font-weight: 500;
    //     color: rgba(165, 164, 164, 1);
    //   }
    // }
    // .indicate {
    //   position: absolute;
    //   bottom: 10px;
    //   right: -10px;
    //   display: inline-block;
    //   width: 60px;
    //   height: 25px;
    //   line-height: 25px;
    //   text-align: center;
    //   background: rgba(88, 68, 190, 1);
    //   box-shadow: 0px 6px 15px 0px rgba(129, 108, 235, 0.56);
    //   border-radius: 20px;
    //   font-size: 10px;
    //   // font-weight:500;
    //   color: rgba(255, 255, 255, 1);
    //   .iconfont {
    //     font-size: 5px;
    //   }
    // }
  }
  img {
    width: 100%;
    height: auto;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    // margin-left: -12px;
    // width: 40%;
    // border-radius: 4px;
  }
  .infoName {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 0 14px;
    box-sizing: border-box;
    .name {
      font-size: 18px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .createTime {
      font-size: 13px;
      font-weight: 400;
      color: rgba(168, 168, 168, 1);
    }
  }
  .star {
    margin: 17px 0 18px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 14px;
    box-sizing: border-box;
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 22px;
      i {
        color: #a8a8a8;
        font-size: 16px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: rgba(168, 168, 168, 1);
        margin-left: 6px;
      }
    }
  }
}
</style>